import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";

import React, { Fragment, Component } from "react";

import moment from "moment";
import omit from "lodash/omit";

import { DayPickerRangeController } from "react-dates";

import Downshift from "downshift";
import clsx from "clsx";

import Heading from "./../../Elements/Heading.js";
import {
  getTextWidth,
  DatePickerMobile,
  DatePickerTablet,
  DatePickerDesktop,
} from "./../../Utils/Utils";

const today = moment();

class QueryDateRangePickerWrapper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      focusedInput: "startDate",
      startDate: moment(this.props.startDate),
      endDate: moment(this.props.endDate),

      defaultTimePresetName: this.props.selectedDate || "Select Range",
      defaultTimePresetTextWidth: {
        width: getTextWidth(this.props.selectedDate || "Select Range"),
      },
      isChecked: false,
    };
  }

  onDatesChange = ({ startDate, endDate }) => {
    // Fix for going back one day
    this.setState({
      startDate: startDate || endDate,
      endDate: endDate || startDate,
    });
  };

  itemToString = (i) => (i ? i.name : "");

  onChangePresetDate = (selected_item, event, data) => {
    // Remove focus
    document.getElementById(event.id + "-input").blur();

    // downshift needs a string
    this.setState({
      defaultTimePresetName: selected_item,
      defaultTimePresetTextWidth: {
        width: getTextWidth(event.inputValue),
      },
    });

    const selectedDate = data.find(({ name }) => name === selected_item);
    const start = moment(selectedDate.from);
    const end = moment(selectedDate.to);

    this.onDatesChange({ startDate: start, endDate: end });
  };

  onStateChangePresetDate = (change, e) => {
    const type = change.type;
    const input = document.getElementById(e.id + "-input");

    if (type === "__autocomplete_item_mouseenter__") {
      input.value = "";
    } else if (type === "__autocomplete_mouseup__") {
      input.value = this.state.defaultTimePresetName;
    } else if (type === "__autocomplete_click_item__") {
      input.blur();
    }
  };

  renderPresetsAutosuggest = () => {
    return (
      <Downshift
        selectedItem={this.state.defaultTimePresetName}
        onChange={(selection, event) =>
          this.onChangePresetDate(selection, event, this.props.dateRanges)
        }
        onStateChange={(changes, stateAndHelpers, e) =>
          this.onStateChangePresetDate(changes, stateAndHelpers, e)
        }
      >
        {({
          getInputProps,
          getItemProps,
          isOpen,
          toggleMenu,
          inputValue,
          highlightedIndex,
          selectedItem,
        }) => (
          <div style={{ position: "relative" }}>
            <input
              className="filters__input"
              style={this.state.defaultTimePresetTextWidth}
              autoCorrect="off"
              autoCapitalize="off"
              spellCheck="false"
              id="downshift-input-0"
              {...getInputProps({
                placeholder: "Search For",
                onClick(event) {
                  return (event.currentTarget.value = "");
                },
                onFocus() {
                  toggleMenu();
                },
              })}
            />

            {isOpen ? (
              <div className="filters-wrapper">
                <div className="date-range-presets-autosuggest">
                  {this.props.dateRanges
                    .filter((i) => {
                      if (inputValue === selectedItem) {
                        return i;
                      } else {
                        return i.name
                          .toLowerCase()
                          .includes(inputValue.toLowerCase());
                      }
                    })
                    .map((item, index) => {
                      let itemClass = clsx(
                        "date-range-presets-autosuggest-item",
                        {
                          "date-range-presets-autosuggest-item--active":
                            highlightedIndex === index,
                          "date-range-presets-autosuggest-item--selected":
                            selectedItem === item.name,
                        }
                      );

                      return (
                        <div
                          {...getItemProps({
                            key: item + index,
                            index,
                            item: this.itemToString(item),
                            className: itemClass,
                          })}
                        >
                          {item.name}
                        </div>
                      );
                    })}
                </div>
              </div>
            ) : null}
          </div>
        )}
      </Downshift>
    );
  };

  handleDateChangeButton = (e) => {
    const { startDate, endDate } = this.state;
    const start = moment(startDate).format("YYYY-MM-DD");
    const end = moment(endDate).format("YYYY-MM-DD");
    this.props.onChange(start, end);
    e.preventDefault();
  };

  handleClearDatesButton = (e) => {
    e.preventDefault();

    this.setState({
      startDate: today,
      endDate: today,
      defaultTimePresetName: "Select Range",
      defaultTimePresetTextWidth: {
        width: getTextWidth("Select Range"),
      },
    });
  };

  renderPresets = () => {
    const start = moment(this.state.startDate).format("MM/DD/YY");
    const end = moment(this.state.endDate).format("MM/DD/YY");

    return (
      <section className="PresetDateRangePicker_panel">
        <button className="datepicker-close-button">
          <i className="datepicker-close-button--icon fas fa-times" />
        </button>

        <Heading size={5} className={"mb-3"}>
          Select Date Range
        </Heading>

        {this.renderPresetsAutosuggest()}

        <div className="mt-3 datepicker-current-dates">
          {start !== "Invalid date" ? start : ""}{" "}
          {end !== "Invalid date" ? "- " + end : ""}
        </div>
      </section>
    );
  };

  renderActions = () => {
    return (
      <div className="d-flex">
        <button
          className="btn btn-apply"
          onClick={(e) => this.handleDateChangeButton(e)}
        >
          Apply
        </button>

        <button
          className="btn btn-link btn-clear"
          onClick={(e) => this.handleClearDatesButton(e)}
        >
          Clear
        </button>
      </div>
    );
  };

  render() {
    const { focusedInput, startDate, endDate } = this.state;
    const props = omit(this.props, [
      "autoFocus",
      "autoFocusEndDate",
      // "initialStartDate",
      // "initialEndDate",
      "showInputs",
      "onChange",
      "selectedDate",
    ]);

    const common_props = {
      ...props,
      startDate: startDate,
      endDate: endDate,
      noBorder: true,
      isOutsideRange: (day) => moment().diff(day) < 0,
      onDatesChange: this.onDatesChange,
      onFocusChange: (focusedInput) =>
        this.setState({ focusedInput: focusedInput || "startDate" }),
      focusedInput: focusedInput,
      hideKeyboardShortcutsPanel: true,
      numberOfMonths: 1,
    };
    delete common_props.dateRanges;

    return (
      <Fragment>
        <DatePickerDesktop>
          <div className="row">
            <div className="col-auto">
              <DayPickerRangeController
                {...common_props}
                orientation="horizontal"
                calendarInfoPosition={"after"}
              />
            </div>
            <div className="col">
              {this.renderPresets()}
              {this.renderActions()}
            </div>
          </div>
        </DatePickerDesktop>

        <DatePickerTablet>
          {this.renderPresets()}

          <DayPickerRangeController
            {...common_props}
            orientation="horizontal"
            calendarInfoPosition={"top"}
          />
          {this.renderActions()}
        </DatePickerTablet>

        <DatePickerMobile>
          {this.renderPresets()}
          <DayPickerRangeController
            {...common_props}
            orientation="horizontal"
            calendarInfoPosition={"top"}
          />
          {this.renderActions()}
        </DatePickerMobile>
      </Fragment>
    );
  }
}

export default QueryDateRangePickerWrapper;
